import { Route } from "react-router-dom";
import { McpAuthorizePage } from "@components/mcpAuthorize/McpAuthorizePage";

export const useRenderMcpAuthorizeRoute = () => (
    <Route path="/mcp-authorize" element={<McpAuthorizePage />} />
);
